/* eslint-disable */
import React from 'react'
import { change } from 'redux-form'

import {
  FilterTypeContainer,
  FilterTypes,
  ListItem,
  InputRadio,
  RadioLabel,
  CheckMark,
  Radio,
} from './styles'

const filterItems = [
  {
    value: 'placa',
    label: 'Placa',
  },
  {
    value: 'tag',
    label: 'Tag',
  },
]

function InputTagOptions({ setOption, name, value, dispatch, setPlateValidation }) {
  
  return (
    <FilterTypeContainer>
      <FilterTypes>
        {filterItems.map((type) => (
          <ListItem key={type.value}>
            <RadioLabel>
              {type.label}
              <InputRadio
                checked={type.value === value}
                name={name}
                onChange={() => {
                  dispatch(change('checkPlateOrIdForm', 'validPlate', ''))
                  dispatch(change('checkPlateOrIdForm', 'identificador', ''))
                  setPlateValidation(false)
                  setOption(type.value)
                }}
                value={type.value}
                type="radio"
              />
              <CheckMark />
              <Radio />
            </RadioLabel>
          </ListItem>
        ))}
      </FilterTypes>
    </FilterTypeContainer>
  )
}

export default InputTagOptions



// WEBPACK FOOTER //
// ./src/app/pages/DashboardStatementPartner/PartnerStatementsFilter/FilterByTag/InputTagOptions.js